<template>
    <div>
        <div v-if="item" class="card shadow-sm mb-0">
            <div class="card-header">
                <h6 class="card-title mb-0">Employee's details</h6>
            </div>
            <div class="card-body">
                <div class="row g-4">
                    <div class="col-md-10">
                        <div class="d-md-flex align-items-center">
                            <img class="me-2 border border-4 shadow-lg border-light rounded-circle me-lg-3"
                                @click="showProfileImg(user.image)" style="width:8rem; height: 8rem;"
                                :src="absoluteUrl(user.image || noImageAvailable)" />
                            <div class="mt-4 mt-md-0">
                                <label class="small text-muted">Full Name</label>
                                <h4 class="mb-2"> {{ getfullName }} </h4>
                                <p class="mb-0">{{ user.email }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row g-3">
                            <div class="col-sm-6 col-md-3">
                                <label class="small text-muted">Employee number</label>
                                <h6 class="mb-0"><router-link @click="closeOpenModal(); removeLeftOverBackDrop()"
                                        :to="`/employees/${item.employee_number}`">{{ item.employee_number }}</router-link>
                                </h6>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="small text-muted">Phone number</label>
                                <h6 class="mb-0">{{ user.mobile }}</h6>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="small text-muted">Gender</label>
                                <h6 class="mb-0 text-capitalize">{{ user.gender }}</h6>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="small text-muted">Marital Status:</label>
                                <h6 class="mb-0">{{ user.marital_status }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.item.user || null
        },
        getfullName() {
            return `${this.user?.last_name}, ${this.user?.first_name} ${this.user?.middle_name}`
        },
    },
    methods:{
        closeOpenModal(){
            this.$parent.$emit('closeModal')
        }
    },
}
</script>

<style></style>